export function generateDemoGameUrl(providerUrl, gameUrl) {
    let generatedUrl = gameUrl;
    if (providerUrl && !gameUrl.includes("http")) {
        generatedUrl = providerUrl + gameUrl;
    }
    return generatedUrl;
}

export const matchProviderUrlToGame = (providers) => {
    const providersMap = providers.reduce((acc, curr) => {
        acc[curr.id] = curr.GameProviderURL || false;
        return acc;
    }, {});
    return (providerId) => {
        return providersMap[providerId];
    };
};